// This list was produced by:
// 1) Fetching a complete list from google API (https://www.googleapis.com/webfonts/v1/webfonts?sort=ALPHA&fields=items%2Ffamily,items%2Fvariants&key=AIzaSyDW_N26TX8gwn7EIKH5EQe1_osRcwQfuMs)
// 2) Filter those without a 'regular' and '700' (bold) variant at mininum
//      fonts.filter((font) => font.variants.includes('700') && font.variants.includes('regular'))
// 3) Rename 'regular' to 'normal' as we're talking about font-weight here
export default [
  {
    family: 'Abhaya Libre',
    variants: ['normal', '500', '600', '700', '800'],
  },
  {
    family: 'Advent Pro',
    variants: ['100', '200', '300', 'normal', '500', '600', '700'],
  },
  {
    family: 'Akshar',
    variants: ['300', 'normal', '500', '600', '700'],
  },
  {
    family: 'Albert Sans',
    variants: [
      '100',
      '200',
      '300',
      'normal',
      '500',
      '600',
      '700',
      '800',
      '900',
      '100italic',
      '200italic',
      '300italic',
      'italic',
      '500italic',
      '600italic',
      '700italic',
      '800italic',
      '900italic',
    ],
  },
  {
    family: 'Alef',
    variants: ['normal', '700'],
  },
  {
    family: 'Alegreya',
    variants: [
      'normal',
      '500',
      '600',
      '700',
      '800',
      '900',
      'italic',
      '500italic',
      '600italic',
      '700italic',
      '800italic',
      '900italic',
    ],
  },
  {
    family: 'Alegreya SC',
    variants: [
      'normal',
      'italic',
      '500',
      '500italic',
      '700',
      '700italic',
      '800',
      '800italic',
      '900',
      '900italic',
    ],
  },
  {
    family: 'Alegreya Sans',
    variants: [
      '100',
      '100italic',
      '300',
      '300italic',
      'normal',
      'italic',
      '500',
      '500italic',
      '700',
      '700italic',
      '800',
      '800italic',
      '900',
      '900italic',
    ],
  },
  {
    family: 'Alegreya Sans SC',
    variants: [
      '100',
      '100italic',
      '300',
      '300italic',
      'normal',
      'italic',
      '500',
      '500italic',
      '700',
      '700italic',
      '800',
      '800italic',
      '900',
      '900italic',
    ],
  },
  {
    family: 'Aleo',
    variants: ['300', '300italic', 'normal', 'italic', '700', '700italic'],
  },
  {
    family: 'Allan',
    variants: ['normal', '700'],
  },
  {
    family: 'Almarai',
    variants: ['300', 'normal', '700', '800'],
  },
  {
    family: 'Almendra',
    variants: ['normal', 'italic', '700', '700italic'],
  },
  {
    family: 'Alumni Sans',
    variants: [
      '100',
      '200',
      '300',
      'normal',
      '500',
      '600',
      '700',
      '800',
      '900',
      '100italic',
      '200italic',
      '300italic',
      'italic',
      '500italic',
      '600italic',
      '700italic',
      '800italic',
      '900italic',
    ],
  },
  {
    family: 'Amaranth',
    variants: ['normal', 'italic', '700', '700italic'],
  },
  {
    family: 'Amatic SC',
    variants: ['normal', '700'],
  },
  {
    family: 'Amiko',
    variants: ['normal', '600', '700'],
  },
  {
    family: 'Amiri',
    variants: ['normal', 'italic', '700', '700italic'],
  },
  {
    family: 'Amita',
    variants: ['normal', '700'],
  },
  {
    family: 'Andada Pro',
    variants: [
      'normal',
      '500',
      '600',
      '700',
      '800',
      'italic',
      '500italic',
      '600italic',
      '700italic',
      '800italic',
    ],
  },
  {
    family: 'Andika',
    variants: ['normal', 'italic', '700', '700italic'],
  },
  {
    family: 'Anek Bangla',
    variants: ['100', '200', '300', 'normal', '500', '600', '700', '800'],
  },
  {
    family: 'Anek Devanagari',
    variants: ['100', '200', '300', 'normal', '500', '600', '700', '800'],
  },
  {
    family: 'Anek Gujarati',
    variants: ['100', '200', '300', 'normal', '500', '600', '700', '800'],
  },
  {
    family: 'Anek Gurmukhi',
    variants: ['100', '200', '300', 'normal', '500', '600', '700', '800'],
  },
  {
    family: 'Anek Kannada',
    variants: ['100', '200', '300', 'normal', '500', '600', '700', '800'],
  },
  {
    family: 'Anek Latin',
    variants: ['100', '200', '300', 'normal', '500', '600', '700', '800'],
  },
  {
    family: 'Anek Malayalam',
    variants: ['100', '200', '300', 'normal', '500', '600', '700', '800'],
  },
  {
    family: 'Anek Odia',
    variants: ['100', '200', '300', 'normal', '500', '600', '700', '800'],
  },
  {
    family: 'Anek Tamil',
    variants: ['100', '200', '300', 'normal', '500', '600', '700', '800'],
  },
  {
    family: 'Anek Telugu',
    variants: ['100', '200', '300', 'normal', '500', '600', '700', '800'],
  },
  {
    family: 'Anonymous Pro',
    variants: ['normal', 'italic', '700', '700italic'],
  },
  {
    family: 'Antonio',
    variants: ['100', '200', '300', 'normal', '500', '600', '700'],
  },
  {
    family: 'Anybody',
    variants: [
      '100',
      '200',
      '300',
      'normal',
      '500',
      '600',
      '700',
      '800',
      '900',
      '100italic',
      '200italic',
      '300italic',
      'italic',
      '500italic',
      '600italic',
      '700italic',
      '800italic',
      '900italic',
    ],
  },
  {
    family: 'Archivo',
    variants: [
      '100',
      '200',
      '300',
      'normal',
      '500',
      '600',
      '700',
      '800',
      '900',
      '100italic',
      '200italic',
      '300italic',
      'italic',
      '500italic',
      '600italic',
      '700italic',
      '800italic',
      '900italic',
    ],
  },
  {
    family: 'Archivo Narrow',
    variants: ['normal', '500', '600', '700', 'italic', '500italic', '600italic', '700italic'],
  },
  {
    family: 'Aref Ruqaa',
    variants: ['normal', '700'],
  },
  {
    family: 'Arima',
    variants: ['100', '200', '300', 'normal', '500', '600', '700'],
  },
  {
    family: 'Arima Madurai',
    variants: ['100', '200', '300', 'normal', '500', '700', '800', '900'],
  },
  {
    family: 'Arimo',
    variants: ['normal', '500', '600', '700', 'italic', '500italic', '600italic', '700italic'],
  },
  {
    family: 'Arsenal',
    variants: ['normal', 'italic', '700', '700italic'],
  },
  {
    family: 'Arvo',
    variants: ['normal', 'italic', '700', '700italic'],
  },
  {
    family: 'Arya',
    variants: ['normal', '700'],
  },
  {
    family: 'Asap',
    variants: ['normal', '500', '600', '700', 'italic', '500italic', '600italic', '700italic'],
  },
  {
    family: 'Asap Condensed',
    variants: ['normal', 'italic', '500', '500italic', '600', '600italic', '700', '700italic'],
  },
  {
    family: 'Assistant',
    variants: ['200', '300', 'normal', '500', '600', '700', '800'],
  },
  {
    family: 'Astloch',
    variants: ['normal', '700'],
  },
  {
    family: 'Asul',
    variants: ['normal', '700'],
  },
  {
    family: 'Athiti',
    variants: ['200', '300', 'normal', '500', '600', '700'],
  },
  {
    family: 'Atkinson Hyperlegible',
    variants: ['normal', 'italic', '700', '700italic'],
  },
  {
    family: 'Atma',
    variants: ['300', 'normal', '500', '600', '700'],
  },
  {
    family: 'Averia Libre',
    variants: ['300', '300italic', 'normal', 'italic', '700', '700italic'],
  },
  {
    family: 'Averia Sans Libre',
    variants: ['300', '300italic', 'normal', 'italic', '700', '700italic'],
  },
  {
    family: 'Averia Serif Libre',
    variants: ['300', '300italic', 'normal', 'italic', '700', '700italic'],
  },
  {
    family: 'Azeret Mono',
    variants: [
      '100',
      '200',
      '300',
      'normal',
      '500',
      '600',
      '700',
      '800',
      '900',
      '100italic',
      '200italic',
      '300italic',
      'italic',
      '500italic',
      '600italic',
      '700italic',
      '800italic',
      '900italic',
    ],
  },
  {
    family: 'B612',
    variants: ['normal', 'italic', '700', '700italic'],
  },
  {
    family: 'B612 Mono',
    variants: ['normal', 'italic', '700', '700italic'],
  },
  {
    family: 'BIZ UDGothic',
    variants: ['normal', '700'],
  },
  {
    family: 'BIZ UDPGothic',
    variants: ['normal', '700'],
  },
  {
    family: 'Bai Jamjuree',
    variants: [
      '200',
      '200italic',
      '300',
      '300italic',
      'normal',
      'italic',
      '500',
      '500italic',
      '600',
      '600italic',
      '700',
      '700italic',
    ],
  },
  {
    family: 'Baloo 2',
    variants: ['normal', '500', '600', '700', '800'],
  },
  {
    family: 'Baloo Bhai 2',
    variants: ['normal', '500', '600', '700', '800'],
  },
  {
    family: 'Baloo Bhaijaan 2',
    variants: ['normal', '500', '600', '700', '800'],
  },
  {
    family: 'Baloo Bhaina 2',
    variants: ['normal', '500', '600', '700', '800'],
  },
  {
    family: 'Baloo Chettan 2',
    variants: ['normal', '500', '600', '700', '800'],
  },
  {
    family: 'Baloo Da 2',
    variants: ['normal', '500', '600', '700', '800'],
  },
  {
    family: 'Baloo Paaji 2',
    variants: ['normal', '500', '600', '700', '800'],
  },
  {
    family: 'Baloo Tamma 2',
    variants: ['normal', '500', '600', '700', '800'],
  },
  {
    family: 'Baloo Tammudu 2',
    variants: ['normal', '500', '600', '700', '800'],
  },
  {
    family: 'Baloo Thambi 2',
    variants: ['normal', '500', '600', '700', '800'],
  },
  {
    family: 'Balsamiq Sans',
    variants: ['normal', 'italic', '700', '700italic'],
  },
  {
    family: 'Barlow',
    variants: [
      '100',
      '100italic',
      '200',
      '200italic',
      '300',
      '300italic',
      'normal',
      'italic',
      '500',
      '500italic',
      '600',
      '600italic',
      '700',
      '700italic',
      '800',
      '800italic',
      '900',
      '900italic',
    ],
  },
  {
    family: 'Barlow Condensed',
    variants: [
      '100',
      '100italic',
      '200',
      '200italic',
      '300',
      '300italic',
      'normal',
      'italic',
      '500',
      '500italic',
      '600',
      '600italic',
      '700',
      '700italic',
      '800',
      '800italic',
      '900',
      '900italic',
    ],
  },
  {
    family: 'Barlow Semi Condensed',
    variants: [
      '100',
      '100italic',
      '200',
      '200italic',
      '300',
      '300italic',
      'normal',
      'italic',
      '500',
      '500italic',
      '600',
      '600italic',
      '700',
      '700italic',
      '800',
      '800italic',
      '900',
      '900italic',
    ],
  },
  {
    family: 'Battambang',
    variants: ['100', '300', 'normal', '700', '900'],
  },
  {
    family: 'Be Vietnam Pro',
    variants: [
      '100',
      '100italic',
      '200',
      '200italic',
      '300',
      '300italic',
      'normal',
      'italic',
      '500',
      '500italic',
      '600',
      '600italic',
      '700',
      '700italic',
      '800',
      '800italic',
      '900',
      '900italic',
    ],
  },
  {
    family: 'Bellota',
    variants: ['300', '300italic', 'normal', 'italic', '700', '700italic'],
  },
  {
    family: 'Bellota Text',
    variants: ['300', '300italic', 'normal', 'italic', '700', '700italic'],
  },
  {
    family: 'BenchNine',
    variants: ['300', 'normal', '700'],
  },
  {
    family: 'Besley',
    variants: [
      'normal',
      '500',
      '600',
      '700',
      '800',
      '900',
      'italic',
      '500italic',
      '600italic',
      '700italic',
      '800italic',
      '900italic',
    ],
  },
  {
    family: 'Big Shoulders Display',
    variants: ['100', '200', '300', 'normal', '500', '600', '700', '800', '900'],
  },
  {
    family: 'Big Shoulders Inline Display',
    variants: ['100', '200', '300', 'normal', '500', '600', '700', '800', '900'],
  },
  {
    family: 'Big Shoulders Inline Text',
    variants: ['100', '200', '300', 'normal', '500', '600', '700', '800', '900'],
  },
  {
    family: 'Big Shoulders Stencil Display',
    variants: ['100', '200', '300', 'normal', '500', '600', '700', '800', '900'],
  },
  {
    family: 'Big Shoulders Stencil Text',
    variants: ['100', '200', '300', 'normal', '500', '600', '700', '800', '900'],
  },
  {
    family: 'Big Shoulders Text',
    variants: ['100', '200', '300', 'normal', '500', '600', '700', '800', '900'],
  },
  {
    family: 'BioRhyme',
    variants: ['200', '300', 'normal', '700', '800'],
  },
  {
    family: 'BioRhyme Expanded',
    variants: ['200', '300', 'normal', '700', '800'],
  },
  {
    family: 'Biryani',
    variants: ['200', '300', 'normal', '600', '700', '800', '900'],
  },
  {
    family: 'Bitter',
    variants: [
      '100',
      '200',
      '300',
      'normal',
      '500',
      '600',
      '700',
      '800',
      '900',
      '100italic',
      '200italic',
      '300italic',
      'italic',
      '500italic',
      '600italic',
      '700italic',
      '800italic',
      '900italic',
    ],
  },
  {
    family: 'Blinker',
    variants: ['100', '200', '300', 'normal', '600', '700', '800', '900'],
  },
  {
    family: 'Bodoni Moda',
    variants: [
      'normal',
      '500',
      '600',
      '700',
      '800',
      '900',
      'italic',
      '500italic',
      '600italic',
      '700italic',
      '800italic',
      '900italic',
    ],
  },
  {
    family: 'Bona Nova',
    variants: ['normal', 'italic', '700'],
  },
  {
    family: 'Brawler',
    variants: ['normal', '700'],
  },
  {
    family: 'Brygada 1918',
    variants: ['normal', '500', '600', '700', 'italic', '500italic', '600italic', '700italic'],
  },
  {
    family: 'Buenard',
    variants: ['normal', '700'],
  },
  {
    family: 'Cabin',
    variants: ['normal', '500', '600', '700', 'italic', '500italic', '600italic', '700italic'],
  },
  {
    family: 'Cabin Condensed',
    variants: ['normal', '500', '600', '700'],
  },
  {
    family: 'Cabin Sketch',
    variants: ['normal', '700'],
  },
  {
    family: 'Cairo',
    variants: ['200', '300', 'normal', '500', '600', '700', '800', '900'],
  },
  {
    family: 'Caladea',
    variants: ['normal', 'italic', '700', '700italic'],
  },
  {
    family: 'Cambay',
    variants: ['normal', 'italic', '700', '700italic'],
  },
  {
    family: 'Cantarell',
    variants: ['normal', 'italic', '700', '700italic'],
  },
  {
    family: 'Cardo',
    variants: ['normal', 'italic', '700'],
  },
  {
    family: 'Catamaran',
    variants: ['100', '200', '300', 'normal', '500', '600', '700', '800', '900'],
  },
  {
    family: 'Caudex',
    variants: ['normal', 'italic', '700', '700italic'],
  },
  {
    family: 'Caveat',
    variants: ['normal', '500', '600', '700'],
  },
  {
    family: 'Chakra Petch',
    variants: [
      '300',
      '300italic',
      'normal',
      'italic',
      '500',
      '500italic',
      '600',
      '600italic',
      '700',
      '700italic',
    ],
  },
  {
    family: 'Changa',
    variants: ['200', '300', 'normal', '500', '600', '700', '800'],
  },
  {
    family: 'Charis SIL',
    variants: ['normal', 'italic', '700', '700italic'],
  },
  {
    family: 'Charm',
    variants: ['normal', '700'],
  },
  {
    family: 'Charmonman',
    variants: ['normal', '700'],
  },
  {
    family: 'Chathura',
    variants: ['100', '300', 'normal', '700', '800'],
  },
  {
    family: 'Cherry Swash',
    variants: ['normal', '700'],
  },
  {
    family: 'Chivo',
    variants: ['300', '300italic', 'normal', 'italic', '700', '700italic', '900', '900italic'],
  },
  {
    family: 'Cinzel',
    variants: ['normal', '500', '600', '700', '800', '900'],
  },
  {
    family: 'Cinzel Decorative',
    variants: ['normal', '700', '900'],
  },
  {
    family: 'Comfortaa',
    variants: ['300', 'normal', '500', '600', '700'],
  },
  {
    family: 'Comic Neue',
    variants: ['300', '300italic', 'normal', 'italic', '700', '700italic'],
  },
  {
    family: 'Commissioner',
    variants: ['100', '200', '300', 'normal', '500', '600', '700', '800', '900'],
  },
  {
    family: 'Content',
    variants: ['normal', '700'],
  },
  {
    family: 'Corben',
    variants: ['normal', '700'],
  },
  {
    family: 'Corinthia',
    variants: ['normal', '700'],
  },
  {
    family: 'Cormorant',
    variants: [
      '300',
      'normal',
      '500',
      '600',
      '700',
      '300italic',
      'italic',
      '500italic',
      '600italic',
      '700italic',
    ],
  },
  {
    family: 'Cormorant Garamond',
    variants: [
      '300',
      '300italic',
      'normal',
      'italic',
      '500',
      '500italic',
      '600',
      '600italic',
      '700',
      '700italic',
    ],
  },
  {
    family: 'Cormorant Infant',
    variants: [
      '300',
      '300italic',
      'normal',
      'italic',
      '500',
      '500italic',
      '600',
      '600italic',
      '700',
      '700italic',
    ],
  },
  {
    family: 'Cormorant SC',
    variants: ['300', 'normal', '500', '600', '700'],
  },
  {
    family: 'Cormorant Unicase',
    variants: ['300', 'normal', '500', '600', '700'],
  },
  {
    family: 'Cormorant Upright',
    variants: ['300', 'normal', '500', '600', '700'],
  },
  {
    family: 'Courier Prime',
    variants: ['normal', 'italic', '700', '700italic'],
  },
  {
    family: 'Cousine',
    variants: ['normal', 'italic', '700', '700italic'],
  },
  {
    family: 'Crimson Pro',
    variants: [
      '200',
      '300',
      'normal',
      '500',
      '600',
      '700',
      '800',
      '900',
      '200italic',
      '300italic',
      'italic',
      '500italic',
      '600italic',
      '700italic',
      '800italic',
      '900italic',
    ],
  },
  {
    family: 'Crimson Text',
    variants: ['normal', 'italic', '600', '600italic', '700', '700italic'],
  },
  {
    family: 'Cuprum',
    variants: ['normal', '500', '600', '700', 'italic', '500italic', '600italic', '700italic'],
  },
  {
    family: 'DM Sans',
    variants: ['normal', 'italic', '500', '500italic', '700', '700italic'],
  },
  {
    family: 'Dancing Script',
    variants: ['normal', '500', '600', '700'],
  },
  {
    family: 'Darker Grotesque',
    variants: ['300', 'normal', '500', '600', '700', '800', '900'],
  },
  {
    family: 'David Libre',
    variants: ['normal', '500', '700'],
  },
  {
    family: 'Delius Unicase',
    variants: ['normal', '700'],
  },
  {
    family: 'Domine',
    variants: ['normal', '500', '600', '700'],
  },
  {
    family: 'Dongle',
    variants: ['300', 'normal', '700'],
  },
  {
    family: 'Dosis',
    variants: ['200', '300', 'normal', '500', '600', '700', '800'],
  },
  {
    family: 'DynaPuff',
    variants: ['normal', '500', '600', '700'],
  },
  {
    family: 'EB Garamond',
    variants: [
      'normal',
      '500',
      '600',
      '700',
      '800',
      'italic',
      '500italic',
      '600italic',
      '700italic',
      '800italic',
    ],
  },
  {
    family: 'Economica',
    variants: ['normal', 'italic', '700', '700italic'],
  },
  {
    family: 'Eczar',
    variants: ['normal', '500', '600', '700', '800'],
  },
  {
    family: 'Edu NSW ACT Foundation',
    variants: ['normal', '500', '600', '700'],
  },
  {
    family: 'Edu QLD Beginner',
    variants: ['normal', '500', '600', '700'],
  },
  {
    family: 'Edu SA Beginner',
    variants: ['normal', '500', '600', '700'],
  },
  {
    family: 'Edu TAS Beginner',
    variants: ['normal', '500', '600', '700'],
  },
  {
    family: 'Edu VIC WA NT Beginner',
    variants: ['normal', '500', '600', '700'],
  },
  {
    family: 'El Messiri',
    variants: ['normal', '500', '600', '700'],
  },
  {
    family: 'Encode Sans',
    variants: ['100', '200', '300', 'normal', '500', '600', '700', '800', '900'],
  },
  {
    family: 'Encode Sans Condensed',
    variants: ['100', '200', '300', 'normal', '500', '600', '700', '800', '900'],
  },
  {
    family: 'Encode Sans Expanded',
    variants: ['100', '200', '300', 'normal', '500', '600', '700', '800', '900'],
  },
  {
    family: 'Encode Sans SC',
    variants: ['100', '200', '300', 'normal', '500', '600', '700', '800', '900'],
  },
  {
    family: 'Encode Sans Semi Condensed',
    variants: ['100', '200', '300', 'normal', '500', '600', '700', '800', '900'],
  },
  {
    family: 'Encode Sans Semi Expanded',
    variants: ['100', '200', '300', 'normal', '500', '600', '700', '800', '900'],
  },
  {
    family: 'Enriqueta',
    variants: ['normal', '500', '600', '700'],
  },
  {
    family: 'Epilogue',
    variants: [
      '100',
      '200',
      '300',
      'normal',
      '500',
      '600',
      '700',
      '800',
      '900',
      '100italic',
      '200italic',
      '300italic',
      'italic',
      '500italic',
      '600italic',
      '700italic',
      '800italic',
      '900italic',
    ],
  },
  {
    family: 'Exo',
    variants: [
      '100',
      '200',
      '300',
      'normal',
      '500',
      '600',
      '700',
      '800',
      '900',
      '100italic',
      '200italic',
      '300italic',
      'italic',
      '500italic',
      '600italic',
      '700italic',
      '800italic',
      '900italic',
    ],
  },
  {
    family: 'Exo 2',
    variants: [
      '100',
      '200',
      '300',
      'normal',
      '500',
      '600',
      '700',
      '800',
      '900',
      '100italic',
      '200italic',
      '300italic',
      'italic',
      '500italic',
      '600italic',
      '700italic',
      '800italic',
      '900italic',
    ],
  },
  {
    family: 'Expletus Sans',
    variants: ['normal', '500', '600', '700', 'italic', '500italic', '600italic', '700italic'],
  },
  {
    family: 'Fahkwang',
    variants: [
      '200',
      '200italic',
      '300',
      '300italic',
      'normal',
      'italic',
      '500',
      '500italic',
      '600',
      '600italic',
      '700',
      '700italic',
    ],
  },
  {
    family: 'Familjen Grotesk',
    variants: ['normal', '500', '600', '700', 'italic', '500italic', '600italic', '700italic'],
  },
  {
    family: 'Farro',
    variants: ['300', 'normal', '500', '700'],
  },
  {
    family: 'Faustina',
    variants: [
      '300',
      'normal',
      '500',
      '600',
      '700',
      '800',
      '300italic',
      'italic',
      '500italic',
      '600italic',
      '700italic',
      '800italic',
    ],
  },
  {
    family: 'Figtree',
    variants: ['300', 'normal', '500', '600', '700', '800', '900'],
  },
  {
    family: 'Finlandica',
    variants: ['normal', '500', '600', '700', 'italic', '500italic', '600italic', '700italic'],
  },
  {
    family: 'Fira Code',
    variants: ['300', 'normal', '500', '600', '700'],
  },
  {
    family: 'Fira Mono',
    variants: ['normal', '500', '700'],
  },
  {
    family: 'Fira Sans',
    variants: [
      '100',
      '100italic',
      '200',
      '200italic',
      '300',
      '300italic',
      'normal',
      'italic',
      '500',
      '500italic',
      '600',
      '600italic',
      '700',
      '700italic',
      '800',
      '800italic',
      '900',
      '900italic',
    ],
  },
  {
    family: 'Fira Sans Condensed',
    variants: [
      '100',
      '100italic',
      '200',
      '200italic',
      '300',
      '300italic',
      'normal',
      'italic',
      '500',
      '500italic',
      '600',
      '600italic',
      '700',
      '700italic',
      '800',
      '800italic',
      '900',
      '900italic',
    ],
  },
  {
    family: 'Fira Sans Extra Condensed',
    variants: [
      '100',
      '100italic',
      '200',
      '200italic',
      '300',
      '300italic',
      'normal',
      'italic',
      '500',
      '500italic',
      '600',
      '600italic',
      '700',
      '700italic',
      '800',
      '800italic',
      '900',
      '900italic',
    ],
  },
  {
    family: 'Frank Ruhl Libre',
    variants: ['300', 'normal', '500', '700', '900'],
  },
  {
    family: 'Fraunces',
    variants: [
      '100',
      '200',
      '300',
      'normal',
      '500',
      '600',
      '700',
      '800',
      '900',
      '100italic',
      '200italic',
      '300italic',
      'italic',
      '500italic',
      '600italic',
      '700italic',
      '800italic',
      '900italic',
    ],
  },
  {
    family: 'Fredoka',
    variants: ['300', 'normal', '500', '600', '700'],
  },
  {
    family: 'Fuzzy Bubbles',
    variants: ['normal', '700'],
  },
  {
    family: 'GFS Neohellenic',
    variants: ['normal', 'italic', '700', '700italic'],
  },
  {
    family: 'Gaegu',
    variants: ['300', 'normal', '700'],
  },
  {
    family: 'Gantari',
    variants: [
      '100',
      '200',
      '300',
      'normal',
      '500',
      '600',
      '700',
      '800',
      '900',
      '100italic',
      '200italic',
      '300italic',
      'italic',
      '500italic',
      '600italic',
      '700italic',
      '800italic',
      '900italic',
    ],
  },
  {
    family: 'Gayathri',
    variants: ['100', 'normal', '700'],
  },
  {
    family: 'Gelasio',
    variants: ['normal', 'italic', '500', '500italic', '600', '600italic', '700', '700italic'],
  },
  {
    family: 'Gemunu Libre',
    variants: ['200', '300', 'normal', '500', '600', '700', '800'],
  },
  {
    family: 'Genos',
    variants: [
      '100',
      '200',
      '300',
      'normal',
      '500',
      '600',
      '700',
      '800',
      '900',
      '100italic',
      '200italic',
      '300italic',
      'italic',
      '500italic',
      '600italic',
      '700italic',
      '800italic',
      '900italic',
    ],
  },
  {
    family: 'Gentium Book Basic',
    variants: ['normal', 'italic', '700', '700italic'],
  },
  {
    family: 'Gentium Book Plus',
    variants: ['normal', 'italic', '700', '700italic'],
  },
  {
    family: 'Gentium Plus',
    variants: ['normal', 'italic', '700', '700italic'],
  },
  {
    family: 'Georama',
    variants: [
      '100',
      '200',
      '300',
      'normal',
      '500',
      '600',
      '700',
      '800',
      '900',
      '100italic',
      '200italic',
      '300italic',
      'italic',
      '500italic',
      '600italic',
      '700italic',
      '800italic',
      '900italic',
    ],
  },
  {
    family: 'Glegoo',
    variants: ['normal', '700'],
  },
  {
    family: 'Glory',
    variants: [
      '100',
      '200',
      '300',
      'normal',
      '500',
      '600',
      '700',
      '800',
      '100italic',
      '200italic',
      '300italic',
      'italic',
      '500italic',
      '600italic',
      '700italic',
      '800italic',
    ],
  },
  {
    family: 'Gluten',
    variants: ['100', '200', '300', 'normal', '500', '600', '700', '800', '900'],
  },
  {
    family: 'Goldman',
    variants: ['normal', '700'],
  },
  {
    family: 'Gorditas',
    variants: ['normal', '700'],
  },
  {
    family: 'Gothic A1',
    variants: ['100', '200', '300', 'normal', '500', '600', '700', '800', '900'],
  },
  {
    family: 'Gowun Batang',
    variants: ['normal', '700'],
  },
  {
    family: 'Grandstander',
    variants: [
      '100',
      '200',
      '300',
      'normal',
      '500',
      '600',
      '700',
      '800',
      '900',
      '100italic',
      '200italic',
      '300italic',
      'italic',
      '500italic',
      '600italic',
      '700italic',
      '800italic',
      '900italic',
    ],
  },
  {
    family: 'Grenze',
    variants: [
      '100',
      '100italic',
      '200',
      '200italic',
      '300',
      '300italic',
      'normal',
      'italic',
      '500',
      '500italic',
      '600',
      '600italic',
      '700',
      '700italic',
      '800',
      '800italic',
      '900',
      '900italic',
    ],
  },
  {
    family: 'Grenze Gotisch',
    variants: ['100', '200', '300', 'normal', '500', '600', '700', '800', '900'],
  },
  {
    family: 'Gudea',
    variants: ['normal', 'italic', '700'],
  },
  {
    family: 'Gupter',
    variants: ['normal', '500', '700'],
  },
  {
    family: 'Gwendolyn',
    variants: ['normal', '700'],
  },
  {
    family: 'Hahmlet',
    variants: ['100', '200', '300', 'normal', '500', '600', '700', '800', '900'],
  },
  {
    family: 'Halant',
    variants: ['300', 'normal', '500', '600', '700'],
  },
  {
    family: 'Hanuman',
    variants: ['100', '300', 'normal', '700', '900'],
  },
  {
    family: 'Harmattan',
    variants: ['normal', '700'],
  },
  {
    family: 'Heebo',
    variants: ['100', '200', '300', 'normal', '500', '600', '700', '800', '900'],
  },
  {
    family: 'Hepta Slab',
    variants: ['100', '200', '300', 'normal', '500', '600', '700', '800', '900'],
  },
  {
    family: 'Hind',
    variants: ['300', 'normal', '500', '600', '700'],
  },
  {
    family: 'Hind Guntur',
    variants: ['300', 'normal', '500', '600', '700'],
  },
  {
    family: 'Hind Madurai',
    variants: ['300', 'normal', '500', '600', '700'],
  },
  {
    family: 'Hind Siliguri',
    variants: ['300', 'normal', '500', '600', '700'],
  },
  {
    family: 'Hind Vadodara',
    variants: ['300', 'normal', '500', '600', '700'],
  },
  {
    family: 'IBM Plex Mono',
    variants: [
      '100',
      '100italic',
      '200',
      '200italic',
      '300',
      '300italic',
      'normal',
      'italic',
      '500',
      '500italic',
      '600',
      '600italic',
      '700',
      '700italic',
    ],
  },
  {
    family: 'IBM Plex Sans',
    variants: [
      '100',
      '100italic',
      '200',
      '200italic',
      '300',
      '300italic',
      'normal',
      'italic',
      '500',
      '500italic',
      '600',
      '600italic',
      '700',
      '700italic',
    ],
  },
  {
    family: 'IBM Plex Sans Arabic',
    variants: ['100', '200', '300', 'normal', '500', '600', '700'],
  },
  {
    family: 'IBM Plex Sans Condensed',
    variants: [
      '100',
      '100italic',
      '200',
      '200italic',
      '300',
      '300italic',
      'normal',
      'italic',
      '500',
      '500italic',
      '600',
      '600italic',
      '700',
      '700italic',
    ],
  },
  {
    family: 'IBM Plex Sans Devanagari',
    variants: ['100', '200', '300', 'normal', '500', '600', '700'],
  },
  {
    family: 'IBM Plex Sans Hebrew',
    variants: ['100', '200', '300', 'normal', '500', '600', '700'],
  },
  {
    family: 'IBM Plex Sans KR',
    variants: ['100', '200', '300', 'normal', '500', '600', '700'],
  },
  {
    family: 'IBM Plex Sans Thai',
    variants: ['100', '200', '300', 'normal', '500', '600', '700'],
  },
  {
    family: 'IBM Plex Sans Thai Looped',
    variants: ['100', '200', '300', 'normal', '500', '600', '700'],
  },
  {
    family: 'IBM Plex Serif',
    variants: [
      '100',
      '100italic',
      '200',
      '200italic',
      '300',
      '300italic',
      'normal',
      'italic',
      '500',
      '500italic',
      '600',
      '600italic',
      '700',
      '700italic',
    ],
  },
  {
    family: 'Ibarra Real Nova',
    variants: ['normal', '500', '600', '700', 'italic', '500italic', '600italic', '700italic'],
  },
  {
    family: 'Imbue',
    variants: ['100', '200', '300', 'normal', '500', '600', '700', '800', '900'],
  },
  {
    family: 'Inconsolata',
    variants: ['200', '300', 'normal', '500', '600', '700', '800', '900'],
  },
  {
    family: 'Inika',
    variants: ['normal', '700'],
  },
  {
    family: 'Inknut Antiqua',
    variants: ['300', 'normal', '500', '600', '700', '800', '900'],
  },
  {
    family: 'Inria Sans',
    variants: ['300', '300italic', 'normal', 'italic', '700', '700italic'],
  },
  {
    family: 'Inria Serif',
    variants: ['300', '300italic', 'normal', 'italic', '700', '700italic'],
  },
  {
    family: 'Inter',
    variants: ['100', '200', '300', 'normal', '500', '600', '700', '800', '900'],
  },
  {
    family: 'Istok Web',
    variants: ['normal', 'italic', '700', '700italic'],
  },
  {
    family: 'Jaldi',
    variants: ['normal', '700'],
  },
  {
    family: 'JetBrains Mono',
    variants: [
      '100',
      '200',
      '300',
      'normal',
      '500',
      '600',
      '700',
      '800',
      '100italic',
      '200italic',
      '300italic',
      'italic',
      '500italic',
      '600italic',
      '700italic',
      '800italic',
    ],
  },
  {
    family: 'Josefin Sans',
    variants: [
      '100',
      '200',
      '300',
      'normal',
      '500',
      '600',
      '700',
      '100italic',
      '200italic',
      '300italic',
      'italic',
      '500italic',
      '600italic',
      '700italic',
    ],
  },
  {
    family: 'Josefin Slab',
    variants: [
      '100',
      '200',
      '300',
      'normal',
      '500',
      '600',
      '700',
      '100italic',
      '200italic',
      '300italic',
      'italic',
      '500italic',
      '600italic',
      '700italic',
    ],
  },
  {
    family: 'Jost',
    variants: [
      '100',
      '200',
      '300',
      'normal',
      '500',
      '600',
      '700',
      '800',
      '900',
      '100italic',
      '200italic',
      '300italic',
      'italic',
      '500italic',
      '600italic',
      '700italic',
      '800italic',
      '900italic',
    ],
  },
  {
    family: 'Judson',
    variants: ['normal', 'italic', '700'],
  },
  {
    family: 'Jura',
    variants: ['300', 'normal', '500', '600', '700'],
  },
  {
    family: 'K2D',
    variants: [
      '100',
      '100italic',
      '200',
      '200italic',
      '300',
      '300italic',
      'normal',
      'italic',
      '500',
      '500italic',
      '600',
      '600italic',
      '700',
      '700italic',
      '800',
      '800italic',
    ],
  },
  {
    family: 'Kadwa',
    variants: ['normal', '700'],
  },
  {
    family: 'Kaisei Decol',
    variants: ['normal', '500', '700'],
  },
  {
    family: 'Kaisei HarunoUmi',
    variants: ['normal', '500', '700'],
  },
  {
    family: 'Kaisei Opti',
    variants: ['normal', '500', '700'],
  },
  {
    family: 'Kaisei Tokumin',
    variants: ['normal', '500', '700', '800'],
  },
  {
    family: 'Kalam',
    variants: ['300', 'normal', '700'],
  },
  {
    family: 'Kameron',
    variants: ['normal', '700'],
  },
  {
    family: 'Kanit',
    variants: [
      '100',
      '100italic',
      '200',
      '200italic',
      '300',
      '300italic',
      'normal',
      'italic',
      '500',
      '500italic',
      '600',
      '600italic',
      '700',
      '700italic',
      '800',
      '800italic',
      '900',
      '900italic',
    ],
  },
  {
    family: 'Kantumruy',
    variants: ['300', 'normal', '700'],
  },
  {
    family: 'Kantumruy Pro',
    variants: [
      '100',
      '200',
      '300',
      'normal',
      '500',
      '600',
      '700',
      '100italic',
      '200italic',
      '300italic',
      'italic',
      '500italic',
      '600italic',
      '700italic',
    ],
  },
  {
    family: 'Karantina',
    variants: ['300', 'normal', '700'],
  },
  {
    family: 'Karla',
    variants: [
      '200',
      '300',
      'normal',
      '500',
      '600',
      '700',
      '800',
      '200italic',
      '300italic',
      'italic',
      '500italic',
      '600italic',
      '700italic',
      '800italic',
    ],
  },
  {
    family: 'Karma',
    variants: ['300', 'normal', '500', '600', '700'],
  },
  {
    family: 'Khand',
    variants: ['300', 'normal', '500', '600', '700'],
  },
  {
    family: 'Khula',
    variants: ['300', 'normal', '600', '700', '800'],
  },
  {
    family: 'KoHo',
    variants: [
      '200',
      '200italic',
      '300',
      '300italic',
      'normal',
      'italic',
      '500',
      '500italic',
      '600',
      '600italic',
      '700',
      '700italic',
    ],
  },
  {
    family: 'Kodchasan',
    variants: [
      '200',
      '200italic',
      '300',
      '300italic',
      'normal',
      'italic',
      '500',
      '500italic',
      '600',
      '600italic',
      '700',
      '700italic',
    ],
  },
  {
    family: 'Koh Santepheap',
    variants: ['100', '300', 'normal', '700', '900'],
  },
  {
    family: 'Kreon',
    variants: ['300', 'normal', '500', '600', '700'],
  },
  {
    family: 'Krub',
    variants: [
      '200',
      '200italic',
      '300',
      '300italic',
      'normal',
      'italic',
      '500',
      '500italic',
      '600',
      '600italic',
      '700',
      '700italic',
    ],
  },
  {
    family: 'Kufam',
    variants: [
      'normal',
      '500',
      '600',
      '700',
      '800',
      '900',
      'italic',
      '500italic',
      '600italic',
      '700italic',
      '800italic',
      '900italic',
    ],
  },
  {
    family: 'Kulim Park',
    variants: [
      '200',
      '200italic',
      '300',
      '300italic',
      'normal',
      'italic',
      '600',
      '600italic',
      '700',
      '700italic',
    ],
  },
  {
    family: 'Kumbh Sans',
    variants: ['100', '200', '300', 'normal', '500', '600', '700', '800', '900'],
  },
  {
    family: 'Laila',
    variants: ['300', 'normal', '500', '600', '700'],
  },
  {
    family: 'Lato',
    variants: [
      '100',
      '100italic',
      '300',
      '300italic',
      'normal',
      'italic',
      '700',
      '700italic',
      '900',
      '900italic',
    ],
  },
  {
    family: 'League Spartan',
    variants: ['100', '200', '300', 'normal', '500', '600', '700', '800', '900'],
  },
  {
    family: 'Lekton',
    variants: ['normal', 'italic', '700'],
  },
  {
    family: 'Lemonada',
    variants: ['300', 'normal', '500', '600', '700'],
  },
  {
    family: 'Lexend',
    variants: ['100', '200', '300', 'normal', '500', '600', '700', '800', '900'],
  },
  {
    family: 'Lexend Deca',
    variants: ['100', '200', '300', 'normal', '500', '600', '700', '800', '900'],
  },
  {
    family: 'Lexend Exa',
    variants: ['100', '200', '300', 'normal', '500', '600', '700', '800', '900'],
  },
  {
    family: 'Lexend Giga',
    variants: ['100', '200', '300', 'normal', '500', '600', '700', '800', '900'],
  },
  {
    family: 'Lexend Mega',
    variants: ['100', '200', '300', 'normal', '500', '600', '700', '800', '900'],
  },
  {
    family: 'Lexend Peta',
    variants: ['100', '200', '300', 'normal', '500', '600', '700', '800', '900'],
  },
  {
    family: 'Lexend Tera',
    variants: ['100', '200', '300', 'normal', '500', '600', '700', '800', '900'],
  },
  {
    family: 'Lexend Zetta',
    variants: ['100', '200', '300', 'normal', '500', '600', '700', '800', '900'],
  },
  {
    family: 'Libre Baskerville',
    variants: ['normal', 'italic', '700'],
  },
  {
    family: 'Libre Bodoni',
    variants: ['normal', '500', '600', '700', 'italic', '500italic', '600italic', '700italic'],
  },
  {
    family: 'Libre Caslon Text',
    variants: ['normal', 'italic', '700'],
  },
  {
    family: 'Libre Franklin',
    variants: [
      '100',
      '200',
      '300',
      'normal',
      '500',
      '600',
      '700',
      '800',
      '900',
      '100italic',
      '200italic',
      '300italic',
      'italic',
      '500italic',
      '600italic',
      '700italic',
      '800italic',
      '900italic',
    ],
  },
  {
    family: 'Life Savers',
    variants: ['normal', '700', '800'],
  },
  {
    family: 'Literata',
    variants: [
      '200',
      '300',
      'normal',
      '500',
      '600',
      '700',
      '800',
      '900',
      '200italic',
      '300italic',
      'italic',
      '500italic',
      '600italic',
      '700italic',
      '800italic',
      '900italic',
    ],
  },
  {
    family: 'Livvic',
    variants: [
      '100',
      '100italic',
      '200',
      '200italic',
      '300',
      '300italic',
      'normal',
      'italic',
      '500',
      '500italic',
      '600',
      '600italic',
      '700',
      '700italic',
      '900',
      '900italic',
    ],
  },
  {
    family: 'Lobster Two',
    variants: ['normal', 'italic', '700', '700italic'],
  },
  {
    family: 'Lora',
    variants: ['normal', '500', '600', '700', 'italic', '500italic', '600italic', '700italic'],
  },
  {
    family: 'Lusitana',
    variants: ['normal', '700'],
  },
  {
    family: 'M PLUS 1',
    variants: ['100', '200', '300', 'normal', '500', '600', '700', '800', '900'],
  },
  {
    family: 'M PLUS 1 Code',
    variants: ['100', '200', '300', 'normal', '500', '600', '700'],
  },
  {
    family: 'M PLUS 1p',
    variants: ['100', '300', 'normal', '500', '700', '800', '900'],
  },
  {
    family: 'M PLUS 2',
    variants: ['100', '200', '300', 'normal', '500', '600', '700', '800', '900'],
  },
  {
    family: 'M PLUS Code Latin',
    variants: ['100', '200', '300', 'normal', '500', '600', '700'],
  },
  {
    family: 'M PLUS Rounded 1c',
    variants: ['100', '300', 'normal', '500', '700', '800', '900'],
  },
  {
    family: 'Mada',
    variants: ['200', '300', 'normal', '500', '600', '700', '900'],
  },
  {
    family: 'Magra',
    variants: ['normal', '700'],
  },
  {
    family: 'Maitree',
    variants: ['200', '300', 'normal', '500', '600', '700'],
  },
  {
    family: 'Mali',
    variants: [
      '200',
      '200italic',
      '300',
      '300italic',
      'normal',
      'italic',
      '500',
      '500italic',
      '600',
      '600italic',
      '700',
      '700italic',
    ],
  },
  {
    family: 'Manjari',
    variants: ['100', 'normal', '700'],
  },
  {
    family: 'Manrope',
    variants: ['200', '300', 'normal', '500', '600', '700', '800'],
  },
  {
    family: 'Manuale',
    variants: [
      '300',
      'normal',
      '500',
      '600',
      '700',
      '800',
      '300italic',
      'italic',
      '500italic',
      '600italic',
      '700italic',
      '800italic',
    ],
  },
  {
    family: 'Markazi Text',
    variants: ['normal', '500', '600', '700'],
  },
  {
    family: 'Martel',
    variants: ['200', '300', 'normal', '600', '700', '800', '900'],
  },
  {
    family: 'Martel Sans',
    variants: ['200', '300', 'normal', '600', '700', '800', '900'],
  },
  {
    family: 'Marvel',
    variants: ['normal', 'italic', '700', '700italic'],
  },
  {
    family: 'Maven Pro',
    variants: ['normal', '500', '600', '700', '800', '900'],
  },
  {
    family: 'Merienda',
    variants: ['normal', '700'],
  },
  {
    family: 'Merriweather',
    variants: ['300', '300italic', 'normal', 'italic', '700', '700italic', '900', '900italic'],
  },
  {
    family: 'Merriweather Sans',
    variants: [
      '300',
      'normal',
      '500',
      '600',
      '700',
      '800',
      '300italic',
      'italic',
      '500italic',
      '600italic',
      '700italic',
      '800italic',
    ],
  },
  {
    family: 'Mina',
    variants: ['normal', '700'],
  },
  {
    family: 'Miriam Libre',
    variants: ['normal', '700'],
  },
  {
    family: 'Mirza',
    variants: ['normal', '500', '600', '700'],
  },
  {
    family: 'Mitr',
    variants: ['200', '300', 'normal', '500', '600', '700'],
  },
  {
    family: 'Mohave',
    variants: [
      '300',
      'normal',
      '500',
      '600',
      '700',
      '300italic',
      'italic',
      '500italic',
      '600italic',
      '700italic',
    ],
  },
  {
    family: 'Monda',
    variants: ['normal', '700'],
  },
  {
    family: 'Montagu Slab',
    variants: ['100', '200', '300', 'normal', '500', '600', '700'],
  },
  {
    family: 'Montserrat',
    variants: [
      '100',
      '200',
      '300',
      'normal',
      '500',
      '600',
      '700',
      '800',
      '900',
      '100italic',
      '200italic',
      '300italic',
      'italic',
      '500italic',
      '600italic',
      '700italic',
      '800italic',
      '900italic',
    ],
  },
  {
    family: 'Montserrat Alternates',
    variants: [
      '100',
      '100italic',
      '200',
      '200italic',
      '300',
      '300italic',
      'normal',
      'italic',
      '500',
      '500italic',
      '600',
      '600italic',
      '700',
      '700italic',
      '800',
      '800italic',
      '900',
      '900italic',
    ],
  },
  {
    family: 'Montserrat Subrayada',
    variants: ['normal', '700'],
  },
  {
    family: 'Mountains of Christmas',
    variants: ['normal', '700'],
  },
  {
    family: 'Mukta',
    variants: ['200', '300', 'normal', '500', '600', '700', '800'],
  },
  {
    family: 'Mukta Mahee',
    variants: ['200', '300', 'normal', '500', '600', '700', '800'],
  },
  {
    family: 'Mukta Malar',
    variants: ['200', '300', 'normal', '500', '600', '700', '800'],
  },
  {
    family: 'Mukta Vaani',
    variants: ['200', '300', 'normal', '500', '600', '700', '800'],
  },
  {
    family: 'Mulish',
    variants: [
      '200',
      '300',
      'normal',
      '500',
      '600',
      '700',
      '800',
      '900',
      '200italic',
      '300italic',
      'italic',
      '500italic',
      '600italic',
      '700italic',
      '800italic',
      '900italic',
    ],
  },
  {
    family: 'Murecho',
    variants: ['100', '200', '300', 'normal', '500', '600', '700', '800', '900'],
  },
  {
    family: 'MuseoModerno',
    variants: [
      '100',
      '200',
      '300',
      'normal',
      '500',
      '600',
      '700',
      '800',
      '900',
      '100italic',
      '200italic',
      '300italic',
      'italic',
      '500italic',
      '600italic',
      '700italic',
      '800italic',
      '900italic',
    ],
  },
  {
    family: 'Nanum Gothic',
    variants: ['normal', '700', '800'],
  },
  {
    family: 'Nanum Gothic Coding',
    variants: ['normal', '700'],
  },
  {
    family: 'Nanum Myeongjo',
    variants: ['normal', '700', '800'],
  },
  {
    family: 'Neuton',
    variants: ['200', '300', 'normal', 'italic', '700', '800'],
  },
  {
    family: 'News Cycle',
    variants: ['normal', '700'],
  },
  {
    family: 'Newsreader',
    variants: [
      '200',
      '300',
      'normal',
      '500',
      '600',
      '700',
      '800',
      '200italic',
      '300italic',
      'italic',
      '500italic',
      '600italic',
      '700italic',
      '800italic',
    ],
  },
  {
    family: 'Niramit',
    variants: [
      '200',
      '200italic',
      '300',
      '300italic',
      'normal',
      'italic',
      '500',
      '500italic',
      '600',
      '600italic',
      '700',
      '700italic',
    ],
  },
  {
    family: 'Nobile',
    variants: ['normal', 'italic', '500', '500italic', '700', '700italic'],
  },
  {
    family: 'Nokora',
    variants: ['100', '300', 'normal', '700', '900'],
  },
  {
    family: 'Noticia Text',
    variants: ['normal', 'italic', '700', '700italic'],
  },
  {
    family: 'Noto Emoji',
    variants: ['300', 'normal', '500', '600', '700'],
  },
  {
    family: 'Noto Kufi Arabic',
    variants: ['100', '200', '300', 'normal', '500', '600', '700', '800', '900'],
  },
  {
    family: 'Noto Naskh Arabic',
    variants: ['normal', '500', '600', '700'],
  },
  {
    family: 'Noto Nastaliq Urdu',
    variants: ['normal', '700'],
  },
  {
    family: 'Noto Rashi Hebrew',
    variants: ['100', '200', '300', 'normal', '500', '600', '700', '800', '900'],
  },
  {
    family: 'Noto Sans',
    variants: [
      '100',
      '100italic',
      '200',
      '200italic',
      '300',
      '300italic',
      'normal',
      'italic',
      '500',
      '500italic',
      '600',
      '600italic',
      '700',
      '700italic',
      '800',
      '800italic',
      '900',
      '900italic',
    ],
  },
  {
    family: 'Noto Sans Adlam',
    variants: ['normal', '500', '600', '700'],
  },
  {
    family: 'Noto Sans Adlam Unjoined',
    variants: ['normal', '500', '600', '700'],
  },
  {
    family: 'Noto Sans Arabic',
    variants: ['100', '200', '300', 'normal', '500', '600', '700', '800', '900'],
  },
  {
    family: 'Noto Sans Armenian',
    variants: ['100', '200', '300', 'normal', '500', '600', '700', '800', '900'],
  },
  {
    family: 'Noto Sans Balinese',
    variants: ['normal', '500', '600', '700'],
  },
  {
    family: 'Noto Sans Bamum',
    variants: ['normal', '500', '600', '700'],
  },
  {
    family: 'Noto Sans Bengali',
    variants: ['100', '200', '300', 'normal', '500', '600', '700', '800', '900'],
  },
  {
    family: 'Noto Sans Canadian Aboriginal',
    variants: ['100', '200', '300', 'normal', '500', '600', '700', '800', '900'],
  },
  {
    family: 'Noto Sans Cham',
    variants: ['100', '200', '300', 'normal', '500', '600', '700', '800', '900'],
  },
  {
    family: 'Noto Sans Cherokee',
    variants: ['100', '200', '300', 'normal', '500', '600', '700', '800', '900'],
  },
  {
    family: 'Noto Sans Devanagari',
    variants: ['100', '200', '300', 'normal', '500', '600', '700', '800', '900'],
  },
  {
    family: 'Noto Sans Display',
    variants: [
      '100',
      '200',
      '300',
      'normal',
      '500',
      '600',
      '700',
      '800',
      '900',
      '100italic',
      '200italic',
      '300italic',
      'italic',
      '500italic',
      '600italic',
      '700italic',
      '800italic',
      '900italic',
    ],
  },
  {
    family: 'Noto Sans Georgian',
    variants: ['100', '200', '300', 'normal', '500', '600', '700', '800', '900'],
  },
  {
    family: 'Noto Sans Gujarati',
    variants: ['100', '200', '300', 'normal', '500', '600', '700', '800', '900'],
  },
  {
    family: 'Noto Sans Gurmukhi',
    variants: ['100', '200', '300', 'normal', '500', '600', '700', '800', '900'],
  },
  {
    family: 'Noto Sans HK',
    variants: ['100', '300', 'normal', '500', '700', '900'],
  },
  {
    family: 'Noto Sans Hanifi Rohingya',
    variants: ['normal', '500', '600', '700'],
  },
  {
    family: 'Noto Sans Hebrew',
    variants: ['100', '200', '300', 'normal', '500', '600', '700', '800', '900'],
  },
  {
    family: 'Noto Sans JP',
    variants: ['100', '300', 'normal', '500', '700', '900'],
  },
  {
    family: 'Noto Sans Javanese',
    variants: ['normal', '700'],
  },
  {
    family: 'Noto Sans KR',
    variants: ['100', '300', 'normal', '500', '700', '900'],
  },
  {
    family: 'Noto Sans Kannada',
    variants: ['100', '200', '300', 'normal', '500', '600', '700', '800', '900'],
  },
  {
    family: 'Noto Sans Kayah Li',
    variants: ['normal', '500', '600', '700'],
  },
  {
    family: 'Noto Sans Khmer',
    variants: ['100', '200', '300', 'normal', '500', '600', '700', '800', '900'],
  },
  {
    family: 'Noto Sans Lao',
    variants: ['100', '200', '300', 'normal', '500', '600', '700', '800', '900'],
  },
  {
    family: 'Noto Sans Lisu',
    variants: ['normal', '500', '600', '700'],
  },
  {
    family: 'Noto Sans Malayalam',
    variants: ['100', '200', '300', 'normal', '500', '600', '700', '800', '900'],
  },
  {
    family: 'Noto Sans Medefaidrin',
    variants: ['normal', '500', '600', '700'],
  },
  {
    family: 'Noto Sans Meetei Mayek',
    variants: ['100', '200', '300', 'normal', '500', '600', '700', '800', '900'],
  },
  {
    family: 'Noto Sans Mono',
    variants: ['100', '200', '300', 'normal', '500', '600', '700', '800', '900'],
  },
  {
    family: 'Noto Sans Myanmar',
    variants: ['100', '200', '300', 'normal', '500', '600', '700', '800', '900'],
  },
  {
    family: 'Noto Sans Ol Chiki',
    variants: ['normal', '500', '600', '700'],
  },
  {
    family: 'Noto Sans Oriya',
    variants: ['100', 'normal', '700', '900'],
  },
  {
    family: 'Noto Sans SC',
    variants: ['100', '300', 'normal', '500', '700', '900'],
  },
  {
    family: 'Noto Sans Sinhala',
    variants: ['100', '200', '300', 'normal', '500', '600', '700', '800', '900'],
  },
  {
    family: 'Noto Sans Sora Sompeng',
    variants: ['normal', '500', '600', '700'],
  },
  {
    family: 'Noto Sans Sundanese',
    variants: ['normal', '500', '600', '700'],
  },
  {
    family: 'Noto Sans Symbols',
    variants: ['100', '200', '300', 'normal', '500', '600', '700', '800', '900'],
  },
  {
    family: 'Noto Sans TC',
    variants: ['100', '300', 'normal', '500', '700', '900'],
  },
  {
    family: 'Noto Sans Tai Tham',
    variants: ['normal', '500', '600', '700'],
  },
  {
    family: 'Noto Sans Tamil',
    variants: ['100', '200', '300', 'normal', '500', '600', '700', '800', '900'],
  },
  {
    family: 'Noto Sans Telugu',
    variants: ['100', '200', '300', 'normal', '500', '600', '700', '800', '900'],
  },
  {
    family: 'Noto Sans Thaana',
    variants: ['100', '200', '300', 'normal', '500', '600', '700', '800', '900'],
  },
  {
    family: 'Noto Sans Thai',
    variants: ['100', '200', '300', 'normal', '500', '600', '700', '800', '900'],
  },
  {
    family: 'Noto Sans Thai Looped',
    variants: ['100', '200', '300', 'normal', '500', '600', '700', '800', '900'],
  },
  {
    family: 'Noto Serif',
    variants: ['normal', 'italic', '700', '700italic'],
  },
  {
    family: 'Noto Serif Armenian',
    variants: ['100', '200', '300', 'normal', '500', '600', '700', '800', '900'],
  },
  {
    family: 'Noto Serif Bengali',
    variants: ['100', '200', '300', 'normal', '500', '600', '700', '800', '900'],
  },
  {
    family: 'Noto Serif Devanagari',
    variants: ['100', '200', '300', 'normal', '500', '600', '700', '800', '900'],
  },
  {
    family: 'Noto Serif Display',
    variants: [
      '100',
      '200',
      '300',
      'normal',
      '500',
      '600',
      '700',
      '800',
      '900',
      '100italic',
      '200italic',
      '300italic',
      'italic',
      '500italic',
      '600italic',
      '700italic',
      '800italic',
      '900italic',
    ],
  },
  {
    family: 'Noto Serif Ethiopic',
    variants: ['100', '200', '300', 'normal', '500', '600', '700', '800', '900'],
  },
  {
    family: 'Noto Serif Georgian',
    variants: ['100', '200', '300', 'normal', '500', '600', '700', '800', '900'],
  },
  {
    family: 'Noto Serif Gujarati',
    variants: ['100', '200', '300', 'normal', '500', '600', '700', '800', '900'],
  },
  {
    family: 'Noto Serif Gurmukhi',
    variants: ['100', '200', '300', 'normal', '500', '600', '700', '800', '900'],
  },
  {
    family: 'Noto Serif HK',
    variants: ['200', '300', 'normal', '500', '600', '700', '800', '900'],
  },
  {
    family: 'Noto Serif Hebrew',
    variants: ['100', '200', '300', 'normal', '500', '600', '700', '800', '900'],
  },
  {
    family: 'Noto Serif JP',
    variants: ['200', '300', 'normal', '500', '600', '700', '900'],
  },
  {
    family: 'Noto Serif KR',
    variants: ['200', '300', 'normal', '500', '600', '700', '900'],
  },
  {
    family: 'Noto Serif Kannada',
    variants: ['100', '200', '300', 'normal', '500', '600', '700', '800', '900'],
  },
  {
    family: 'Noto Serif Khmer',
    variants: ['100', '200', '300', 'normal', '500', '600', '700', '800', '900'],
  },
  {
    family: 'Noto Serif Lao',
    variants: ['100', '200', '300', 'normal', '500', '600', '700', '800', '900'],
  },
  {
    family: 'Noto Serif Malayalam',
    variants: ['100', '200', '300', 'normal', '500', '600', '700', '800', '900'],
  },
  {
    family: 'Noto Serif Myanmar',
    variants: ['100', '200', '300', 'normal', '500', '600', '700', '800', '900'],
  },
  {
    family: 'Noto Serif Nyiakeng Puachue Hmong',
    variants: ['normal', '500', '600', '700'],
  },
  {
    family: 'Noto Serif SC',
    variants: ['200', '300', 'normal', '500', '600', '700', '900'],
  },
  {
    family: 'Noto Serif Sinhala',
    variants: ['100', '200', '300', 'normal', '500', '600', '700', '800', '900'],
  },
  {
    family: 'Noto Serif TC',
    variants: ['200', '300', 'normal', '500', '600', '700', '900'],
  },
  {
    family: 'Noto Serif Tamil',
    variants: [
      '100',
      '200',
      '300',
      'normal',
      '500',
      '600',
      '700',
      '800',
      '900',
      '100italic',
      '200italic',
      '300italic',
      'italic',
      '500italic',
      '600italic',
      '700italic',
      '800italic',
      '900italic',
    ],
  },
  {
    family: 'Noto Serif Telugu',
    variants: ['100', '200', '300', 'normal', '500', '600', '700', '800', '900'],
  },
  {
    family: 'Noto Serif Thai',
    variants: ['100', '200', '300', 'normal', '500', '600', '700', '800', '900'],
  },
  {
    family: 'Noto Serif Tibetan',
    variants: ['100', '200', '300', 'normal', '500', '600', '700', '800', '900'],
  },
  {
    family: 'Noto Serif Yezidi',
    variants: ['normal', '500', '600', '700'],
  },
  {
    family: 'Nunito',
    variants: [
      '200',
      '300',
      'normal',
      '500',
      '600',
      '700',
      '800',
      '900',
      '200italic',
      '300italic',
      'italic',
      '500italic',
      '600italic',
      '700italic',
      '800italic',
      '900italic',
    ],
  },
  {
    family: 'Nunito Sans',
    variants: [
      '200',
      '200italic',
      '300',
      '300italic',
      'normal',
      'italic',
      '600',
      '600italic',
      '700',
      '700italic',
      '800',
      '800italic',
      '900',
      '900italic',
    ],
  },
  {
    family: 'Old Standard TT',
    variants: ['normal', 'italic', '700'],
  },
  {
    family: 'Oleo Script',
    variants: ['normal', '700'],
  },
  {
    family: 'Oleo Script Swash Caps',
    variants: ['normal', '700'],
  },
  {
    family: 'Open Sans',
    variants: [
      '300',
      'normal',
      '500',
      '600',
      '700',
      '800',
      '300italic',
      'italic',
      '500italic',
      '600italic',
      '700italic',
      '800italic',
    ],
  },
  {
    family: 'Orbitron',
    variants: ['normal', '500', '600', '700', '800', '900'],
  },
  {
    family: 'Oswald',
    variants: ['200', '300', 'normal', '500', '600', '700'],
  },
  {
    family: 'Outfit',
    variants: ['100', '200', '300', 'normal', '500', '600', '700', '800', '900'],
  },
  {
    family: 'Overlock',
    variants: ['normal', 'italic', '700', '700italic', '900', '900italic'],
  },
  {
    family: 'Overpass',
    variants: [
      '100',
      '200',
      '300',
      'normal',
      '500',
      '600',
      '700',
      '800',
      '900',
      '100italic',
      '200italic',
      '300italic',
      'italic',
      '500italic',
      '600italic',
      '700italic',
      '800italic',
      '900italic',
    ],
  },
  {
    family: 'Overpass Mono',
    variants: ['300', 'normal', '500', '600', '700'],
  },
  {
    family: 'Oxanium',
    variants: ['200', '300', 'normal', '500', '600', '700', '800'],
  },
  {
    family: 'Oxygen',
    variants: ['300', 'normal', '700'],
  },
  {
    family: 'PT Sans',
    variants: ['normal', 'italic', '700', '700italic'],
  },
  {
    family: 'PT Sans Caption',
    variants: ['normal', '700'],
  },
  {
    family: 'PT Sans Narrow',
    variants: ['normal', '700'],
  },
  {
    family: 'PT Serif',
    variants: ['normal', 'italic', '700', '700italic'],
  },
  {
    family: 'Padauk',
    variants: ['normal', '700'],
  },
  {
    family: 'Palanquin',
    variants: ['100', '200', '300', 'normal', '500', '600', '700'],
  },
  {
    family: 'Palanquin Dark',
    variants: ['normal', '500', '600', '700'],
  },
  {
    family: 'Passion One',
    variants: ['normal', '700', '900'],
  },
  {
    family: 'Petrona',
    variants: [
      '100',
      '200',
      '300',
      'normal',
      '500',
      '600',
      '700',
      '800',
      '900',
      '100italic',
      '200italic',
      '300italic',
      'italic',
      '500italic',
      '600italic',
      '700italic',
      '800italic',
      '900italic',
    ],
  },
  {
    family: 'Philosopher',
    variants: ['normal', 'italic', '700', '700italic'],
  },
  {
    family: 'Piazzolla',
    variants: [
      '100',
      '200',
      '300',
      'normal',
      '500',
      '600',
      '700',
      '800',
      '900',
      '100italic',
      '200italic',
      '300italic',
      'italic',
      '500italic',
      '600italic',
      '700italic',
      '800italic',
      '900italic',
    ],
  },
  {
    family: 'Play',
    variants: ['normal', '700'],
  },
  {
    family: 'Playfair Display',
    variants: [
      'normal',
      '500',
      '600',
      '700',
      '800',
      '900',
      'italic',
      '500italic',
      '600italic',
      '700italic',
      '800italic',
      '900italic',
    ],
  },
  {
    family: 'Playfair Display SC',
    variants: ['normal', 'italic', '700', '700italic', '900', '900italic'],
  },
  {
    family: 'Plus Jakarta Sans',
    variants: [
      '200',
      '300',
      'normal',
      '500',
      '600',
      '700',
      '800',
      '200italic',
      '300italic',
      'italic',
      '500italic',
      '600italic',
      '700italic',
      '800italic',
    ],
  },
  {
    family: 'Podkova',
    variants: ['normal', '500', '600', '700', '800'],
  },
  {
    family: 'Poppins',
    variants: [
      '100',
      '100italic',
      '200',
      '200italic',
      '300',
      '300italic',
      'normal',
      'italic',
      '500',
      '500italic',
      '600',
      '600italic',
      '700',
      '700italic',
      '800',
      '800italic',
      '900',
      '900italic',
    ],
  },
  {
    family: 'Pragati Narrow',
    variants: ['normal', '700'],
  },
  {
    family: 'Pridi',
    variants: ['200', '300', 'normal', '500', '600', '700'],
  },
  {
    family: 'Prompt',
    variants: [
      '100',
      '100italic',
      '200',
      '200italic',
      '300',
      '300italic',
      'normal',
      'italic',
      '500',
      '500italic',
      '600',
      '600italic',
      '700',
      '700italic',
      '800',
      '800italic',
      '900',
      '900italic',
    ],
  },
  {
    family: 'Proza Libre',
    variants: [
      'normal',
      'italic',
      '500',
      '500italic',
      '600',
      '600italic',
      '700',
      '700italic',
      '800',
      '800italic',
    ],
  },
  {
    family: 'Public Sans',
    variants: [
      '100',
      '200',
      '300',
      'normal',
      '500',
      '600',
      '700',
      '800',
      '900',
      '100italic',
      '200italic',
      '300italic',
      'italic',
      '500italic',
      '600italic',
      '700italic',
      '800italic',
      '900italic',
    ],
  },
  {
    family: 'Puritan',
    variants: ['normal', 'italic', '700', '700italic'],
  },
  {
    family: 'Quantico',
    variants: ['normal', 'italic', '700', '700italic'],
  },
  {
    family: 'Quattrocento',
    variants: ['normal', '700'],
  },
  {
    family: 'Quattrocento Sans',
    variants: ['normal', 'italic', '700', '700italic'],
  },
  {
    family: 'Quicksand',
    variants: ['300', 'normal', '500', '600', '700'],
  },
  {
    family: 'Qwitcher Grypen',
    variants: ['normal', '700'],
  },
  {
    family: 'Radio Canada',
    variants: [
      '300',
      'normal',
      '500',
      '600',
      '700',
      '300italic',
      'italic',
      '500italic',
      '600italic',
      '700italic',
    ],
  },
  {
    family: 'Rajdhani',
    variants: ['300', 'normal', '500', '600', '700'],
  },
  {
    family: 'Raleway',
    variants: [
      '100',
      '200',
      '300',
      'normal',
      '500',
      '600',
      '700',
      '800',
      '900',
      '100italic',
      '200italic',
      '300italic',
      'italic',
      '500italic',
      '600italic',
      '700italic',
      '800italic',
      '900italic',
    ],
  },
  {
    family: 'Rambla',
    variants: ['normal', 'italic', '700', '700italic'],
  },
  {
    family: 'Ranga',
    variants: ['normal', '700'],
  },
  {
    family: 'Rasa',
    variants: [
      '300',
      'normal',
      '500',
      '600',
      '700',
      '300italic',
      'italic',
      '500italic',
      '600italic',
      '700italic',
    ],
  },
  {
    family: 'Readex Pro',
    variants: ['200', '300', 'normal', '500', '600', '700'],
  },
  {
    family: 'Recursive',
    variants: ['300', 'normal', '500', '600', '700', '800', '900'],
  },
  {
    family: 'Red Hat Display',
    variants: [
      '300',
      'normal',
      '500',
      '600',
      '700',
      '800',
      '900',
      '300italic',
      'italic',
      '500italic',
      '600italic',
      '700italic',
      '800italic',
      '900italic',
    ],
  },
  {
    family: 'Red Hat Mono',
    variants: [
      '300',
      'normal',
      '500',
      '600',
      '700',
      '300italic',
      'italic',
      '500italic',
      '600italic',
      '700italic',
    ],
  },
  {
    family: 'Red Hat Text',
    variants: [
      '300',
      'normal',
      '500',
      '600',
      '700',
      '300italic',
      'italic',
      '500italic',
      '600italic',
      '700italic',
    ],
  },
  {
    family: 'Red Rose',
    variants: ['300', 'normal', '500', '600', '700'],
  },
  {
    family: 'Redacted Script',
    variants: ['300', 'normal', '700'],
  },
  {
    family: 'Reem Kufi',
    variants: ['normal', '500', '600', '700'],
  },
  {
    family: 'Roboto',
    variants: [
      '100',
      '100italic',
      '300',
      '300italic',
      'normal',
      'italic',
      '500',
      '500italic',
      '700',
      '700italic',
      '900',
      '900italic',
    ],
  },
  {
    family: 'Roboto Condensed',
    variants: ['300', '300italic', 'normal', 'italic', '700', '700italic'],
  },
  {
    family: 'Roboto Mono',
    variants: [
      '100',
      '200',
      '300',
      'normal',
      '500',
      '600',
      '700',
      '100italic',
      '200italic',
      '300italic',
      'italic',
      '500italic',
      '600italic',
      '700italic',
    ],
  },
  {
    family: 'Roboto Serif',
    variants: [
      '100',
      '200',
      '300',
      'normal',
      '500',
      '600',
      '700',
      '800',
      '900',
      '100italic',
      '200italic',
      '300italic',
      'italic',
      '500italic',
      '600italic',
      '700italic',
      '800italic',
      '900italic',
    ],
  },
  {
    family: 'Roboto Slab',
    variants: ['100', '200', '300', 'normal', '500', '600', '700', '800', '900'],
  },
  {
    family: 'Rokkitt',
    variants: ['100', '200', '300', 'normal', '500', '600', '700', '800', '900'],
  },
  {
    family: 'Rosario',
    variants: [
      '300',
      'normal',
      '500',
      '600',
      '700',
      '300italic',
      'italic',
      '500italic',
      '600italic',
      '700italic',
    ],
  },
  {
    family: 'Rowdies',
    variants: ['300', 'normal', '700'],
  },
  {
    family: 'Rubik',
    variants: [
      '300',
      'normal',
      '500',
      '600',
      '700',
      '800',
      '900',
      '300italic',
      'italic',
      '500italic',
      '600italic',
      '700italic',
      '800italic',
      '900italic',
    ],
  },
  {
    family: 'Ruda',
    variants: ['normal', '500', '600', '700', '800', '900'],
  },
  {
    family: 'Rufina',
    variants: ['normal', '700'],
  },
  {
    family: 'STIX Two Text',
    variants: ['normal', '500', '600', '700', 'italic', '500italic', '600italic', '700italic'],
  },
  {
    family: 'Sahitya',
    variants: ['normal', '700'],
  },
  {
    family: 'Saira',
    variants: [
      '100',
      '200',
      '300',
      'normal',
      '500',
      '600',
      '700',
      '800',
      '900',
      '100italic',
      '200italic',
      '300italic',
      'italic',
      '500italic',
      '600italic',
      '700italic',
      '800italic',
      '900italic',
    ],
  },
  {
    family: 'Saira Condensed',
    variants: ['100', '200', '300', 'normal', '500', '600', '700', '800', '900'],
  },
  {
    family: 'Saira Extra Condensed',
    variants: ['100', '200', '300', 'normal', '500', '600', '700', '800', '900'],
  },
  {
    family: 'Saira Semi Condensed',
    variants: ['100', '200', '300', 'normal', '500', '600', '700', '800', '900'],
  },
  {
    family: 'Sansita',
    variants: ['normal', 'italic', '700', '700italic', '800', '800italic', '900', '900italic'],
  },
  {
    family: 'Sansita Swashed',
    variants: ['300', 'normal', '500', '600', '700', '800', '900'],
  },
  {
    family: 'Sarabun',
    variants: [
      '100',
      '100italic',
      '200',
      '200italic',
      '300',
      '300italic',
      'normal',
      'italic',
      '500',
      '500italic',
      '600',
      '600italic',
      '700',
      '700italic',
      '800',
      '800italic',
    ],
  },
  {
    family: 'Sarala',
    variants: ['normal', '700'],
  },
  {
    family: 'Sarpanch',
    variants: ['normal', '500', '600', '700', '800', '900'],
  },
  {
    family: 'Scada',
    variants: ['normal', 'italic', '700', '700italic'],
  },
  {
    family: 'Scheherazade New',
    variants: ['normal', '700'],
  },
  {
    family: 'Sen',
    variants: ['normal', '700', '800'],
  },
  {
    family: 'Share',
    variants: ['normal', 'italic', '700', '700italic'],
  },
  {
    family: 'Shippori Mincho',
    variants: ['normal', '500', '600', '700', '800'],
  },
  {
    family: 'Shippori Mincho B1',
    variants: ['normal', '500', '600', '700', '800'],
  },
  {
    family: 'Signika',
    variants: ['300', 'normal', '500', '600', '700'],
  },
  {
    family: 'Signika Negative',
    variants: ['300', 'normal', '500', '600', '700'],
  },
  {
    family: 'Silkscreen',
    variants: ['normal', '700'],
  },
  {
    family: 'Sintony',
    variants: ['normal', '700'],
  },
  {
    family: 'Skranji',
    variants: ['normal', '700'],
  },
  {
    family: 'Smooch Sans',
    variants: ['100', '200', '300', 'normal', '500', '600', '700', '800', '900'],
  },
  {
    family: 'Solway',
    variants: ['300', 'normal', '500', '700', '800'],
  },
  {
    family: 'Sora',
    variants: ['100', '200', '300', 'normal', '500', '600', '700', '800'],
  },
  {
    family: 'Source Code Pro',
    variants: [
      '200',
      '300',
      'normal',
      '500',
      '600',
      '700',
      '800',
      '900',
      '200italic',
      '300italic',
      'italic',
      '500italic',
      '600italic',
      '700italic',
      '800italic',
      '900italic',
    ],
  },
  {
    family: 'Source Sans 3',
    variants: [
      '200',
      '300',
      'normal',
      '500',
      '600',
      '700',
      '800',
      '900',
      '200italic',
      '300italic',
      'italic',
      '500italic',
      '600italic',
      '700italic',
      '800italic',
      '900italic',
    ],
  },
  {
    family: 'Source Sans Pro',
    variants: [
      '200',
      '200italic',
      '300',
      '300italic',
      'normal',
      'italic',
      '600',
      '600italic',
      '700',
      '700italic',
      '900',
      '900italic',
    ],
  },
  {
    family: 'Source Serif 4',
    variants: [
      '200',
      '300',
      'normal',
      '500',
      '600',
      '700',
      '800',
      '900',
      '200italic',
      '300italic',
      'italic',
      '500italic',
      '600italic',
      '700italic',
      '800italic',
      '900italic',
    ],
  },
  {
    family: 'Source Serif Pro',
    variants: [
      '200',
      '200italic',
      '300',
      '300italic',
      'normal',
      'italic',
      '600',
      '600italic',
      '700',
      '700italic',
      '900',
      '900italic',
    ],
  },
  {
    family: 'Space Grotesk',
    variants: ['300', 'normal', '500', '600', '700'],
  },
  {
    family: 'Space Mono',
    variants: ['normal', 'italic', '700', '700italic'],
  },
  {
    family: 'Spectral',
    variants: [
      '200',
      '200italic',
      '300',
      '300italic',
      'normal',
      'italic',
      '500',
      '500italic',
      '600',
      '600italic',
      '700',
      '700italic',
      '800',
      '800italic',
    ],
  },
  {
    family: 'Spectral SC',
    variants: [
      '200',
      '200italic',
      '300',
      '300italic',
      'normal',
      'italic',
      '500',
      '500italic',
      '600',
      '600italic',
      '700',
      '700italic',
      '800',
      '800italic',
    ],
  },
  {
    family: 'Spline Sans',
    variants: ['300', 'normal', '500', '600', '700'],
  },
  {
    family: 'Spline Sans Mono',
    variants: [
      '300',
      'normal',
      '500',
      '600',
      '700',
      '300italic',
      'italic',
      '500italic',
      '600italic',
      '700italic',
    ],
  },
  {
    family: 'Srisakdi',
    variants: ['normal', '700'],
  },
  {
    family: 'Stardos Stencil',
    variants: ['normal', '700'],
  },
  {
    family: 'Stick No Bills',
    variants: ['200', '300', 'normal', '500', '600', '700', '800'],
  },
  {
    family: 'Sulphur Point',
    variants: ['300', 'normal', '700'],
  },
  {
    family: 'Sumana',
    variants: ['normal', '700'],
  },
  {
    family: 'Sura',
    variants: ['normal', '700'],
  },
  {
    family: 'Suwannaphum',
    variants: ['100', '300', 'normal', '700', '900'],
  },
  {
    family: 'Syncopate',
    variants: ['normal', '700'],
  },
  {
    family: 'Syne',
    variants: ['normal', '500', '600', '700', '800'],
  },
  {
    family: 'Tai Heritage Pro',
    variants: ['normal', '700'],
  },
  {
    family: 'Tajawal',
    variants: ['200', '300', 'normal', '500', '700', '800', '900'],
  },
  {
    family: 'Tangerine',
    variants: ['normal', '700'],
  },
  {
    family: 'Taviraj',
    variants: [
      '100',
      '100italic',
      '200',
      '200italic',
      '300',
      '300italic',
      'normal',
      'italic',
      '500',
      '500italic',
      '600',
      '600italic',
      '700',
      '700italic',
      '800',
      '800italic',
      '900',
      '900italic',
    ],
  },
  {
    family: 'Teko',
    variants: ['300', 'normal', '500', '600', '700'],
  },
  {
    family: 'Texturina',
    variants: [
      '100',
      '200',
      '300',
      'normal',
      '500',
      '600',
      '700',
      '800',
      '900',
      '100italic',
      '200italic',
      '300italic',
      'italic',
      '500italic',
      '600italic',
      '700italic',
      '800italic',
      '900italic',
    ],
  },
  {
    family: 'Thasadith',
    variants: ['normal', 'italic', '700', '700italic'],
  },
  {
    family: 'The Nautigal',
    variants: ['normal', '700'],
  },
  {
    family: 'Tienne',
    variants: ['normal', '700', '900'],
  },
  {
    family: 'Tillana',
    variants: ['normal', '500', '600', '700', '800'],
  },
  {
    family: 'Tinos',
    variants: ['normal', 'italic', '700', '700italic'],
  },
  {
    family: 'Titillium Web',
    variants: [
      '200',
      '200italic',
      '300',
      '300italic',
      'normal',
      'italic',
      '600',
      '600italic',
      '700',
      '700italic',
      '900',
    ],
  },
  {
    family: 'Tomorrow',
    variants: [
      '100',
      '100italic',
      '200',
      '200italic',
      '300',
      '300italic',
      'normal',
      'italic',
      '500',
      '500italic',
      '600',
      '600italic',
      '700',
      '700italic',
      '800',
      '800italic',
      '900',
      '900italic',
    ],
  },
  {
    family: 'Tourney',
    variants: [
      '100',
      '200',
      '300',
      'normal',
      '500',
      '600',
      '700',
      '800',
      '900',
      '100italic',
      '200italic',
      '300italic',
      'italic',
      '500italic',
      '600italic',
      '700italic',
      '800italic',
      '900italic',
    ],
  },
  {
    family: 'Trirong',
    variants: [
      '100',
      '100italic',
      '200',
      '200italic',
      '300',
      '300italic',
      'normal',
      'italic',
      '500',
      '500italic',
      '600',
      '600italic',
      '700',
      '700italic',
      '800',
      '800italic',
      '900',
      '900italic',
    ],
  },
  {
    family: 'Trispace',
    variants: ['100', '200', '300', 'normal', '500', '600', '700', '800'],
  },
  {
    family: 'Trochut',
    variants: ['normal', 'italic', '700'],
  },
  {
    family: 'Truculenta',
    variants: ['100', '200', '300', 'normal', '500', '600', '700', '800', '900'],
  },
  {
    family: 'Turret Road',
    variants: ['200', '300', 'normal', '500', '700', '800'],
  },
  {
    family: 'Ubuntu',
    variants: ['300', '300italic', 'normal', 'italic', '500', '500italic', '700', '700italic'],
  },
  {
    family: 'Ubuntu Mono',
    variants: ['normal', 'italic', '700', '700italic'],
  },
  {
    family: 'Unkempt',
    variants: ['normal', '700'],
  },
  {
    family: 'Unna',
    variants: ['normal', 'italic', '700', '700italic'],
  },
  {
    family: 'Urbanist',
    variants: [
      '100',
      '200',
      '300',
      'normal',
      '500',
      '600',
      '700',
      '800',
      '900',
      '100italic',
      '200italic',
      '300italic',
      'italic',
      '500italic',
      '600italic',
      '700italic',
      '800italic',
      '900italic',
    ],
  },
  {
    family: 'Varta',
    variants: ['300', 'normal', '500', '600', '700'],
  },
  {
    family: 'Vazirmatn',
    variants: ['100', '200', '300', 'normal', '500', '600', '700', '800', '900'],
  },
  {
    family: 'Vesper Libre',
    variants: ['normal', '500', '700', '900'],
  },
  {
    family: 'Volkhov',
    variants: ['normal', 'italic', '700', '700italic'],
  },
  {
    family: 'Vollkorn',
    variants: [
      'normal',
      '500',
      '600',
      '700',
      '800',
      '900',
      'italic',
      '500italic',
      '600italic',
      '700italic',
      '800italic',
      '900italic',
    ],
  },
  {
    family: 'Vollkorn SC',
    variants: ['normal', '600', '700', '900'],
  },
  {
    family: 'Work Sans',
    variants: [
      '100',
      '200',
      '300',
      'normal',
      '500',
      '600',
      '700',
      '800',
      '900',
      '100italic',
      '200italic',
      '300italic',
      'italic',
      '500italic',
      '600italic',
      '700italic',
      '800italic',
      '900italic',
    ],
  },
  {
    family: 'Yaldevi',
    variants: ['200', '300', 'normal', '500', '600', '700'],
  },
  {
    family: 'Yanone Kaffeesatz',
    variants: ['200', '300', 'normal', '500', '600', '700'],
  },
  {
    family: 'Yantramanav',
    variants: ['100', '300', 'normal', '500', '700', '900'],
  },
  {
    family: 'Yrsa',
    variants: [
      '300',
      'normal',
      '500',
      '600',
      '700',
      '300italic',
      'italic',
      '500italic',
      '600italic',
      '700italic',
    ],
  },
  {
    family: 'Zen Kaku Gothic Antique',
    variants: ['300', 'normal', '500', '700', '900'],
  },
  {
    family: 'Zen Kaku Gothic New',
    variants: ['300', 'normal', '500', '700', '900'],
  },
  {
    family: 'Zen Maru Gothic',
    variants: ['300', 'normal', '500', '700', '900'],
  },
  {
    family: 'Zen Old Mincho',
    variants: ['normal', '700', '900'],
  },
  {
    family: 'Zilla Slab',
    variants: [
      '300',
      '300italic',
      'normal',
      'italic',
      '500',
      '500italic',
      '600',
      '600italic',
      '700',
      '700italic',
    ],
  },
  {
    family: 'Zilla Slab Highlight',
    variants: ['normal', '700'],
  },
];
